import { provideHttpClient, withInterceptors  } from '@angular/common/http'; // ⬅️ added
import { ErrorHandler, inject,isDevMode, provideAppInitializer   } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules,provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';

import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { Capacitor } from '@capacitor/core';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/interceptors/auth-interceptor'; // add out auth interceptor for http
import { DbService } from './app/services/core/db.service'; // database service so we can init

/*===END sENTRY=====*/
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import * as SentryAngular from '@sentry/angular';
import * as Sentry from '@sentry/capacitor';
import { defineCustomElements as jeepSqlite } from 'jeep-sqlite/loader';
import { provideMarkdown } from 'ngx-markdown';

import { isIgnorableSentryEvent } from './app/utils/sentry/sentry-filter.utils'; //Sentry util to keep this page tidier

import { BUILD_INFO } from './app/core/build-info.generated'; //config values for sentry etc

jeepSqlite(window);

// Errors only: no tracing/replay integrations added
Sentry.init(
  {
    dsn: "https://b5002d7c81171c61504d707ad41588d6@o1061157.ingest.us.sentry.io/4509886684332037",
    environment: 'Production',        // or 'Staging' etc.
    // Optional but recommended for readable stack traces later:
    release: BUILD_INFO.sentryRelease,
    dist: BUILD_INFO.sentryDist,
    //enabled: !isDevMode(),  // disable in dev mode
    beforeSend( event ) {
     if (isIgnorableSentryEvent(event)) {
        return null;
      }

      return event;
    },
  },
  SentryAngular.init
);
// Call the element loader before the bootstrapModule/bootstrapApplication call
defineCustomElements(window);


bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient( withInterceptors([authInterceptor]) ),  //added fot http

    provideMarkdown(),

    // ✅ Angular 19 way: run async DB init before the app starts
    provideAppInitializer(async () => {
      //if (Capacitor.getPlatform() === 'web') return;     // ⬅️ skip web for now
      try {
        await inject(DbService).init();
      } catch (e) {
        console.warn('[DB] init skipped:', e);
      }
    }),

    // Sentry Angular ErrorHandler (errors only)
    { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler({ showDialog: false }) }, //added for sentry
  ],
}).catch(err => console.error(err));
